import { ReactElement } from 'react';
import { useTranslate } from '@client/i18n/hooks';
import { Formik } from 'formik';
import * as yup from 'yup';
import { Body } from './Body';
import { Props } from './Form.types';
import { FIELD_NAME } from './FormContainer.types';

const Form = (props: Props): ReactElement => {
  const t = useTranslate();
  const { onSubmit } = props;

  const validationSchema = (): Record<string, any> => yup.object().shape({
    [FIELD_NAME.debitorId]: yup.string().required(t('Required')),
    [FIELD_NAME.invoiceId]: yup.string().required(t('Required')),
  });

  return (
    <Formik
      initialValues={{
        [FIELD_NAME.debitorId]: '',
        [FIELD_NAME.invoiceId]: '',
      }}
      onSubmit={onSubmit}
      validationSchema={validationSchema}
    >
      <Body {...props} />
    </Formik>
  );
};

export { Form };
